import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { ServiceCRUD } from '../../../../../shared/crud/ServiceCRUD';
@Injectable()
export class AnaliseMargemBi02Service extends ServiceCRUD {
  private baseUrlService: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router)
    this.baseUrlService = environment.URL_API
   }

   protected getURL(): string {
    return `${this.baseUrlService}/analise_margem_bi02`
  }
  
  public definirURLTotais() {
    this.baseUrlService = 'passagens';
  }

  public getTotais(marcas: object): Promise<any> {
    this.definirURLTotais();
    return this.listar([], marcas);
  }

  public getDadosPrevisoes(filtro: object): Promise<any> {
    return this.listar([], filtro);
  }
}
